import {
  VehicleCatalogMarket,
  VehicleCatalogMarketLabels,
  VehicleCatalogOrigin,
  VehicleCatalogOriginLabels,
  type VehicleCatalogNodeRecord
} from '@navio/nsdk';
import { catalogNodeLabel, getLabelMapFromEntries } from 'noddi-util';

const MARKET_LABEL = getLabelMapFromEntries(VehicleCatalogMarket, VehicleCatalogMarketLabels);

/**
 * `Audi · A3 (2012–2020)` — the parent disambiguates models that share a name across makes, and the
 * label reads the same on a trigger, in a dropdown row and on a saved value.
 */
export const vehicleCatalogNodeOptionLabel = (
  node: Pick<VehicleCatalogNodeRecord, 'name' | 'parentName' | 'yearFrom' | 'yearTo'>
) => [node.parentName, catalogNodeLabel(node)].filter(Boolean).join(' · ');

/**
 * Everything that tells look-alike siblings apart: parent, sales markets, provider slug — and the
 * origin only when the node is one we maintain, the exception worth seeing. Wheel-Size is never
 * named: almost every row comes from there, and saying so on every row is noise.
 */
export const vehicleCatalogNodeOptionContext = (node: VehicleCatalogNodeRecord) =>
  [
    node.parentName,
    node.markets.map((market) => MARKET_LABEL[market]).join(', '),
    node.sourceSlug,
    node.origin === VehicleCatalogOrigin.MANUAL ? VehicleCatalogOriginLabels[node.origin] : null
  ]
    .filter(Boolean)
    .join(' · ');
